import script from "./DesignToggle.vue?vue&type=script&setup=true&lang=js"
export * from "./DesignToggle.vue?vue&type=script&setup=true&lang=js"

import "./DesignToggle.vue?vue&type=style&index=0&id=23ae59f8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-23ae59f8"]])

export default __exports__